import { DateInputFieldTextValues } from '@sparknz/journeys-common/dist/components/CheckoutFields/DateInputField/DateInputField';
import { W3cddlData } from '@sparknz/tracking';

import { CheckoutFormCartFragment$data } from '__generated__/CheckoutFormCartFragment.graphql';
import { CheckoutFormDataFragment$data } from '__generated__/CheckoutFormDataFragment.graphql';
import { CheckoutFormStructureFragment$data } from '__generated__/CheckoutFormStructureFragment.graphql';
import {
  BIOMETRICS_SECTION_ID,
  CREDIT_CHECK_SECTION_ID,
  DELIVERY_SECTION_ID,
  PAYMENT_SECTION_ID,
  REVIEW_SECTION_ID,
  SETUP_SECTION_ID,
} from './constants';

export type FieldValue = string | number | boolean;

export type FormData = {
  [key: string]: FormFieldValue;
};

export type FormFieldValue = Partial<FieldValue | DateInputFieldTextValues>;

export type CheckoutModel = CheckoutFormStructureFragment$data;
export type SectionModel = CheckoutModel['sections'][0];
export type StepModel = SectionModel['steps'][0];
export type FieldModel = StepModel['fields'][0];
export type OptionModel = FieldModel['options'][0];

export type CheckoutDataEntry =
  CheckoutFormDataFragment$data['sections'][0]['steps'][0]['entries'][0];

export type CheckoutCart = Omit<
  CheckoutFormCartFragment$data,
  ' $fragmentType'
>;

export type CheckoutCartBundle = CheckoutCart['bundles'][0];
export type CheckoutCartItems = CheckoutCartBundle['items'];
export type CheckoutCartItem = CheckoutCartItems[0];

export type CheckoutData = Partial<CheckoutFormDataFragment$data>;
export type CheckoutSection = CheckoutData['sections'][0];
export type CheckoutStepData = CheckoutSection['steps'][0];

export type CheckoutContentFieldKey =
  | 'checkout.creditCheck.infoBanner.description'
  | 'checkout.biometrics.idRequiredInfoBanner'
  | 'checkout.biometrics.successInfoBanner'
  | 'checkout.biometrics.timedOutInfoBanner'
  | 'checkout.biometrics.noMatchInfoBanner';

export type CheckoutSectionId =
  | typeof SETUP_SECTION_ID
  | typeof DELIVERY_SECTION_ID
  | typeof REVIEW_SECTION_ID
  | typeof BIOMETRICS_SECTION_ID
  | typeof PAYMENT_SECTION_ID
  | typeof CREDIT_CHECK_SECTION_ID;

export enum ProcessContext {
  NewOffer = 'NEW_OFFER',
  ModifyOffer = 'MODIFY_OFFER',
  ChangeOffer = 'CHANGE_OFFER',
}
export type StockInfo = W3cddlData['transaction'][0]['attributes']['stockInfo'];
